module.exports = __webpack_public_path__ + "static/media/screen2.dc8ba44f.png";